import { AxiosRequestConfig } from "axios";

export const postCreateApplicationConfig: AxiosRequestConfig = {
  method: "post",
  url: `/application`,
};
